import React, { useEffect, useState } from "react";
// import "./libraryBox.css";
import Checkbox from "@mui/material/Checkbox";
import { grey, orange } from "@mui/material/colors";
import { Tooltip } from "@mui/material";

import CircleCheckedFilled from "@mui/icons-material/CheckCircle";
import CircleUnchecked from "@mui/icons-material/RadioButtonUnchecked";
import { useSelector } from "react-redux";

const LibraryBox = ({ 
  question, 
  selectedQuestion, 
  setSelectedQuestion, 
  setSelQueID, 
  sourceLibrary,
  assessmentDetails
 }) => {
  const [isChecked, setIsChecked] = useState(false);
  const [questionTypeByB4STypeId, setQuestionTypeByB4STypeId] = useState({});
  useEffect(() => {
    const isQuestionChecked = localStorage.getItem(`isChecked_${question.id}`);
    setIsChecked(!!isQuestionChecked);
  }, [question.id]);
  const questionType = useSelector((state) => state.initialData.questionTypes);
  useEffect(() => {
    let b4sQuestionTypes = {}
    questionType.map((val) => {
      if (b4sQuestionTypes[val.b4sQuestionType] === undefined) {
        b4sQuestionTypes[val.b4sQuestionType] = val; 
      }
    })
    setQuestionTypeByB4STypeId(b4sQuestionTypes)
  },[])
  const handleAddingQuestion = (isChecked) => {
    if (isChecked) {
      setIsChecked(isChecked);
      const isDup = selectedQuestion.some(que => que.id === question.id);
      if (isDup) {
      } else {
        setSelQueID((prev) => [...prev, question.id]);
        localStorage.setItem(`isChecked_${question.id}`, "true");
        if (sourceLibrary == "FROM_SCHOOL_LIBRARY") {
          setSelectedQuestion((prev) => [
            ...prev,
            {
              id: question?.id,
              standard_id: question?.standard?.id,
              subject_id: question?.subject?.id,
              section_id: question?.section?.id,
              book_id: question?.book?.id,
              chapter_id: question?.chapter?.id,
              type_id: question?.type?.id,
              question_type: question?.type?.is_manually_graded ? "true" : "false",
              domain_id: question?.domain?.id,
              skill_id: question?.skill?.id,
              difficulty_level: question?.difficulty_level?.id,
              title: question?.title,
              correct_score: question?.correct_score,
              is_mandatory: question?.is_mandatory,
              add_to: question?.add_to,
              attachments: question?.attachments,
              options: question?.options,
              correct_answers: question?.correct_answers,
              question : question
            },
          ]);
        }else{
          setSelectedQuestion((prev) => [
            ...prev,
            {
              b4sQuestion : question?.id,
              standard_id: assessmentDetails?.standard_id?.id,
              subject_id: assessmentDetails?.subject_id?.id,
              section_id: assessmentDetails?.section_id?.id,
              book_id: question?.book?.id,
              chapter_id: question?.chapter?.id,
              type_id: questionTypeByB4STypeId[question?.type?.id]['id'],
              question_type: question?.type?.is_manually_graded ? "true" : "false",
              domain_id: question?.domain?.id,
              skill_id: question?.skill?.id,
              difficulty_level: question?.difficulty_level?.id,
              title: question?.title,
              correct_score: question?.correct_score,
              is_mandatory: question?.is_mandatory,
              add_to: question?.add_to,
              attachments: question?.attachments,
              options: question?.options,
              correct_answers: question?.correct_answers,
              question : question
            },
          ]);
        }
      }
    } else {
      setIsChecked(false);
      localStorage.removeItem(`isChecked_${question.id}`);
      setSelectedQuestion((prev) => {
        return prev.filter((item) => item.id !== question.id);
      });
      setSelQueID((prev) => {
        return prev.filter((item) => item !== question.id);
      });
    }
  };

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate();
    const month = dateObj.getUTCMonth() + 1;
    const year = dateObj.getUTCFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };

  return (
    <>
      <div className="hw_library_card">
        <div
          className="hw_selected_topic_subject"
        // onClick={(e) => setClick(true)}
        >
          {/* Add tooltip for question title */}
          {<Tooltip
            title={question?.title}
            arrow
            placement="top"
            enterDelay={200}
            leaveDelay={100}
          >
            <div className="subjectNm">{question?.title}</div>
          </Tooltip>}
        </div>
        <div className="hw_library_card_description">{question.domain.name} | {question.skill.name} | {question.type.name}</div>
        <div className="hw_library_card_description">{question.difficulty_level.name} | {question.book.name} : {question.chapter.chapterName}</div>
        <div className="d-flex  justify-content-between ab">
          <span className="hw_added_on">
            Added On &nbsp;{timeHelper(question?.created_at)}
          </span>
          <Checkbox
            checked={isChecked}
            onChange={(e) => handleAddingQuestion(e.target.checked)}
            className="m-0 p-0"
            // icon={<CircleUnchecked />}
            // checkedIcon={<CircleCheckedFilled />}
            sx={{
              color: grey[300],
              "&.Mui-checked": {
                color: orange[800],
              },
            }}
          />
        </div>
      </div>
    </>
  );
};

export default LibraryBox;
